import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CacheControlService {
  constructor(private http: HttpClient) {}

  private static readonly FORM_HEADERS = new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
  });

  private toUrlEncoded(data: Record<string, any>): string {
    const params = new URLSearchParams();
    Object.keys(data).forEach(key => {
      const val = data[key];
      if (val !== undefined && val !== null) {
        params.set(key, typeof val === 'object' ? JSON.stringify(val) : String(val));
      }
    });
    return params.toString();
  }

  private postForm(url: string, data: Record<string, any>): Observable<any> {
    return this.http.post<any>(url, this.toUrlEncoded(data), {
      headers: CacheControlService.FORM_HEADERS,
      withCredentials: true,
    });
  }

  saveCache(commonApiUrl: string, cacheData: any): Observable<any> {
    return this.postForm(`${commonApiUrl}/saveCache`, {
      json_string: JSON.stringify(cacheData || {}),
    });
  }

  fetchCacheObjControlDetails(commonApiUrl: string, clientKey: string): Observable<any> {
    return this.postForm(`${commonApiUrl}/fetchCacheObjControlDetails`, {
      client_key: clientKey,
    });
  }

  refreshCachedObject(commonApiUrl: string, objectId: number): Observable<any> {
    return this.postForm(`${commonApiUrl}/refreshCachedObject`, { objectId });
  }

  refreshAllCachedObject(commonApiUrl: string, refreshSwitch: string): Observable<any> {
    return this.postForm(`${commonApiUrl}/refreshAllCachedObject`, { refreshSwitch });
  }

  removeCachedObject(commonApiUrl: string, objectId: number): Observable<any> {
    return this.postForm(`${commonApiUrl}/removeCachedObject`, { objectId });
  }

  enableDisableCaching(commonApiUrl: string, objectId: number, useCache: 'Y' | 'N'): Observable<any> {
    return this.postForm(`${commonApiUrl}/enableDisableCaching`, { objectId, useCache });
  }

  downloadCachedObject(commonApiUrl: string, objectId: number): Observable<any> {
    const params = new HttpParams().set('objectId', String(objectId));
    return this.http.get(`${commonApiUrl}/downloadCachedObject`, {
      params,
      withCredentials: true,
      responseType: 'arraybuffer',
      observe: 'response',
    });
  }

  getAllCacheKeysAndCount(commonApiUrl: string): Observable<any> {
    return this.http.get<any>(`${commonApiUrl}/getAllCacheKeysAndCount`, { withCredentials: true });
  }

  getCacheData(commonApiUrl: string, cacheName: string, cacheKey: string): Observable<any> {
    const params = new HttpParams().set('cache_name', cacheName).set('cache_key', cacheKey);
    return this.http.get<any>(`${commonApiUrl}/getCacheData`, { params, withCredentials: true });
  }

  obtainBOFromCache(commonApiUrl: string, objectKey: string, procInParams: string, fetchFromCache: 'Y' | 'N'): Observable<any> {
    const params = new HttpParams()
      .set('object_key', objectKey)
      .set('proc_in_params', procInParams)
      .set('fetch_from_cache', fetchFromCache);
    return this.http.get<any>(`${commonApiUrl}/obtainBOFromCache`, { params, withCredentials: true });
  }

  deleteIndexes(baseUrl: string, deleteAll: string): Observable<any> {
    return this.http.post<any>(
      `${baseUrl}/deleteIndexes?deleteall=${deleteAll}`,
      this.toUrlEncoded({}),
      { headers: CacheControlService.FORM_HEADERS, withCredentials: true },
    );
  }

  evictAllCache(commonApiUrl: string): Observable<any> {
    return this.http.get<any>(`${commonApiUrl}/evictAllCache`, { withCredentials: true });
  }

  evictCacheObj(commonApiUrl: string, cacheName: string): Observable<any> {
    return this.http.get<any>(`${commonApiUrl}/evictCacheObj?cacheName=${encodeURIComponent(cacheName)}`, {
      withCredentials: true,
    });
  }
}
